/**
 * JS per a a la vista "partials/header.blade.php"
 */

const jqDropdownmegas = $('header.header .dropdownmega');

jqDropdownmegas.each(function () {
    const jqDropdownmega = $(this);
    const jqContent = jqDropdownmega.find('.dropdownmega-content');
    let mouseXMin = 0;
    let mouseXMax = $(window).width();
    let mouseYMin = 0;
    let mouseYMax = $(window).height();
    jqDropdownmega.on('mouseenter', function (event) {
        jqDropdownmegas.removeClass('hover');
        jqDropdownmega.addClass('hover');
        mouseXMin = jqContent.offset().left;
        mouseXMax = mouseXMin + jqContent.outerWidth();
        mouseYMin = jqDropdownmega.offset().top;
        mouseYMax = jqContent.offset().top + jqContent.outerHeight();
        function onMouseMove (event) {
            const mousePosX = event.pageX;
            const mousePosY = event.pageY;
            if (mousePosX < mouseXMin || mousePosX > mouseXMax ||
                mousePosY < mouseYMin || mousePosY > mouseYMax)
            {
                jqDropdownmega.removeClass('hover');
                $(window).unbind('mousemove', onMouseMove);
            }
        }
        $(window).on('mousemove', onMouseMove);
    });
});
